/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import { useCallback, useEffect, useRef } from 'react'
import { useRecoilValue } from 'recoil'

import APIEndPoints from '@models/api/apiEndpoints'
import { fetchDataSelector } from '@recoil/selectors/selectors'
import utils from '@utils/utils'

const useTrackAnprLastActivity = ({
  autoTrack = true,
  domainName = utils?.apiDomainName?.privateLand?.name,
} = {}) => {
  const getCoreData = useRecoilValue(fetchDataSelector)
  const hasAutoTrackedRef = useRef(false)

  const trackLastActivity = useCallback(async () => {
    return getCoreData(
      APIEndPoints?.lastActivity?.method,
      APIEndPoints?.lastActivity?.url,
      null,
      null,
      null,
      false,
      domainName,
      false
    )
  }, [domainName, getCoreData])

  useEffect(() => {
    if (!autoTrack || hasAutoTrackedRef?.current) {
      return
    }

    hasAutoTrackedRef.current = true
    trackLastActivity()
  }, [autoTrack, trackLastActivity])

  return { trackLastActivity }
}

export default useTrackAnprLastActivity
